import PropTypes from 'prop-types';
import ProductCardPrice from './product_card_price';

export const ProductCard = ({
  title,
  imagePath,
  imageAlt,
  badgeLabel,
  badgeColour,
  price,
  link,
}) => (
  <div className="card card--compressed">
    {badgeLabel && (
      <div
        className="badge badge-pill"
        style={{ backgroundColor: badgeColour }}
      >
        {badgeLabel}
      </div>
    )}

    <div className="card__image">
      <div
        className="picture__wrapper"
        style={{ paddingBottom: `${(2 / 3) * 100}%` }}
      >
        <picture>
          <img src={imagePath} alt={imageAlt || ''} />
        </picture>
      </div>
    </div>

    <div className="card__body">
      <div className="content">
        <h3 className="card__title">{title}</h3>
      </div>
      {price && (
        <div className="mt-3">
          <ProductCardPrice
            {...{
              fromToggle: price.fromToggle,
              basePrice: price.basePrice,
              salePrice: price.salePrice,
              priceDefinition: price.priceDefinition,
            }}
          />
        </div>
      )}
    </div>

    <a className="stretched-link" href={link} title={title} />
  </div>
);

ProductCard.propTypes = {
  title: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  badgeLabel: PropTypes.string,
  badgeColour: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  price: PropTypes.object,
  link: PropTypes.string.isRequired,
};

export default ProductCard;
